import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const ImageSlider = ({ images, isPlaying, loop }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let intervalId;
    if (isPlaying) {
      intervalId = setInterval(() => {
        setIndex((prevIndex) => {
          // 判斷是否循環
          if (prevIndex + 1 < images.length) {
            return prevIndex + 1; // 正常進行到下一張
          } else if (loop) {
            return 0; // 如果循環開啟，則返回第一張
          }
          return prevIndex; // 如果不循環，保持在最後一張
        });
      }, 30); // 每1000毫秒切換一次圖片
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [images.length, isPlaying, loop]); // 監聽loop的變化

  return (
    <figure style={{ width: "100%" }}>
      <img
        src={images[index]}
        alt={`Slide ${index}`}
        style={{ width: "100%", height: "auto" }}
      />
    </figure>
  );
};

ImageSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  isPlaying: PropTypes.bool.isRequired,
  loop: PropTypes.bool.isRequired,
};

export default ImageSlider;
